import axios from 'axios';

const baseURL = require("../../config/admin.config.json")[process.env.NODE_ENV].VUE_APP_API_SERVER_HOST;

export default axios.create({
    baseURL
});